export function PhaseBadge({ phase, t }: { phase: string; t: (key: string, fallback?: string) => string }) {
  const styles: Record<string, { dot: string; bg: string; text: string }> = {
    initial: { dot: 'bg-blue-500', bg: 'bg-blue-50', text: 'text-blue-800' },
    active: { dot: 'bg-amber-500', bg: 'bg-amber-50', text: 'text-amber-800' },
    acute: { dot: 'bg-amber-500', bg: 'bg-amber-50', text: 'text-amber-800' },
    maintenance: { dot: 'bg-green-500', bg: 'bg-green-50', text: 'text-green-800' },
    rehabilitative: { dot: 'bg-green-500', bg: 'bg-green-50', text: 'text-green-800' },
    wellness: { dot: 'bg-green-500', bg: 'bg-green-50', text: 'text-green-800' },
  };
  const s = styles[phase?.toLowerCase()] || styles.initial;
  const carePhaseKeys: Record<string, string> = {
    initial: 'carePhases.initial',
    active: 'carePhases.active',
    acute: 'carePhases.active',
    maintenance: 'carePhases.maintenance',
    rehabilitative: 'carePhases.maintenance',
    wellness: 'carePhases.wellness',
  };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-medium ${s.bg} ${s.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {t(carePhaseKeys[phase?.toLowerCase()] || 'carePhases.initial', phase || 'Initial')}
    </span>
  );
}
